// Libraries
import { SxProps, Dialog, Paper, DialogTitle, DialogActions, Theme } from '@mui/material'
// Components
import CustomButton from '../../../CustomButton/CustomButton'
import { useModal } from '../../../../../../store/ModalProvider'

/**
 * ## CustomModalMassApprovalConfirm component
 *
 * - @returns {JSX.Element} The rendered CustomModalMassApprovalConfirm component
 */
const CustomModalMassApprovalConfirm: React.FC = () => {
	const customeStyles: {
		dialog: SxProps<Theme>
		title: SxProps<Theme>
	} = {
		dialog: {
			pointerEvents: 'auto',
			color: 'var(--primary-dark)',
			padding: '1.5rem 1rem',
		},
		title: {
			fontWeight: 600,
			fontSize: '1rem',
			fontFamily: 'Poppins, sans-serif',
			color: 'var(--primary-dark)',
		},
	}

	const { isOpen, closeModal, modalData, modalTitle, modalHandlers } = useModal()

	const [handleConfirm] = modalHandlers

	if (!modalData) {
		return null
	}

	return (
		<Dialog
			sx={{ ...customeStyles.dialog }}
			open={isOpen}
		>
			<Paper sx={{}}>
				<DialogTitle
					id='error-modal-title'
					variant='h6'
					component='h2'
					sx={{ ...customeStyles.title }}
				>
					{modalTitle} ({Array.isArray(modalData) && modalData.length})?
				</DialogTitle>
				<DialogActions
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
					}}
				>
					<CustomButton
						size='small'
						variant='text'
						onClick={closeModal}
						sx={{ marginLeft: 'auto' }}
					>
						Cancelar
					</CustomButton>
					<CustomButton
						size='small'
						onClick={handleConfirm}
					>
						Aprovar
					</CustomButton>
				</DialogActions>
			</Paper>
		</Dialog>
	)
}

export default CustomModalMassApprovalConfirm
